import React, { ReactNode } from 'react';
import { View } from '@react-pdf/renderer';
import { Card, Divider, ItemNameTitle, TextMid } from 'components/Pdf/PdfUI';
import { styles } from 'components/Pdf/PdfUI.styles';
import { theme } from 'styles';
import { OrderPdfText } from './MyOrdersDetailPdfPage';

const InformationRow = ({
  isLastElement,
  label,
  data,
}: {
  isLastElement: boolean;
  label: ReactNode;
  data: string | undefined;
}) => {
  if (!data) {
    return null;
  }
  return (
    <>
      <View style={[styles.col, { width: '100%', height: 20, justifyContent: 'center', padding: '0 5px' }]}>
        <TextMid>
          {label}
          {': '}
          {data}
        </TextMid>
      </View>
      {!isLastElement && <Divider />}
    </>
  );
};

export const OrderInformationCard = ({
  text,
  orderedBy,
  clientNumber,
  distributor,
  billingAccount,
}: {
  text: OrderPdfText;
  orderedBy: string | undefined;
  clientNumber: string | undefined;
  distributor: string | undefined;
  billingAccount: string | undefined;
}) => {
  const items = [
    { label: text.orderBy, data: orderedBy },
    { label: text.clientNumber, data: clientNumber },
    { label: text.distributor, data: distributor },
    { label: text.billingAccount, data: billingAccount },
  ];

  return (
    <Card
      title={<ItemNameTitle>{text.informations}</ItemNameTitle>}
      height={100}
      width={210}
      noPadding
      titleBackgroundColor={theme.color.primary_brand_bg}
    >
      <View style={[styles.col]}>
        {items.map((item, index) => (
          <InformationRow
            isLastElement={index === items.length - 1}
            key={item.data}
            label={item.label}
            data={item.data}
          />
        ))}
      </View>
    </Card>
  );
};
